import { useEffect } from 'react';
import { EXTERNAL_LINKS } from '../../constants/links';

const getStoreUrl = () => {
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return EXTERNAL_LINKS.APP_STORE;
  if (/android/i.test(ua)) return EXTERNAL_LINKS.GOOGLE_PLAY_STORE;
  return null;
};

const Download = () => {
  useEffect(() => {
    const url = getStoreUrl();
    if (url) {
      window.location.replace(url);
    }
  }, []);

  const iosUrl = EXTERNAL_LINKS.APP_STORE;
  const androidUrl = EXTERNAL_LINKS.GOOGLE_PLAY_STORE;

  return (
    <div style={{ textAlign: 'center', padding: '60px 20px' }}>
      <h2>Download the OW app</h2>
      <p>Choose your platform:</p>
      <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginTop: '24px' }}>
        <a href={androidUrl} rel="noopener noreferrer">Google Play</a>
        <a href={iosUrl} rel="noopener noreferrer">App Store</a>
      </div>
    </div>
  );
};

export default Download;
